export const queryString = (
  searchParams: URLSearchParams,
  key: string,
  all: { [key: string]: string } = {},
): string[] => (searchParams.has(key) ? searchParams.getAll(key) : Object.keys(all));
